export const outdoorQuestions = [
  {
    questionNumber: 1,
    choices: {
      A: "The women are sitting on a bench.",
      B: "The women are jogging in the park.",
      C: "The women are strolling in the park.",
      D: "The women are picking up leaves.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여자들이 공원을 산책하고 있음\n" +
      "오답 설명: (A) 벤치에 앉아있지 않음, (B) 조깅하지 않음, (D) 낙엽을 줍지 않음",
  },
  {
    questionNumber: 2,
    choices: {
      A: "The man is jogging along the river.",
      B: "The man is sitting on a bench with his dog.",
      C: "The man is walking his dog.",
      D: "The man is feeding his dog.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 남자가 개를 산책시키고 있음\n" +
      "오답 설명: (A) 강가를 조깅하지 않음, (B) 벤치에 앉아있지 않음, (D) 개에게 먹이를 주지 않음",
  },
  {
    questionNumber: 3,
    choices: {
      A: "The couple is sitting on a bench.",
      B: "The man is jogging in the park.",
      C: "The woman is feeding a dog.",
      D: "The couple is strolling with their dog.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 커플이 개와 함께 산책하고 있음\n" +
      "오답 설명: (A) 벤치에 앉아있지 않음, (B) 조깅하지 않음, (C) 개에게 먹이를 주지 않음",
  },
  {
    questionNumber: 4,
    choices: {
      A: "The man is taking a seat on the bench.",
      B: "The man is holding an umbrella.",
      C: "The man is holding a book.",
      D: "The man is talking on the phone.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 남자가 책을 들고 있음\n" +
      "오답 설명: (A) 'taking a seat'는 '자리에 앉는 중'이란 뜻인데 이미 앉아있음, (B) 우산을 들고 있지 않음, (D) 전화통화를 하지 않음",
  },
  {
    questionNumber: 5,
    choices: {
      A: "The couple is riding bicycles.",
      B: "The couple is standing next to a bench.",
      C: "The couple is sitting on a bench.",
      D: "A bicycle is leaning against the bench.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 커플이 벤치에 앉아있음\n" +
      "오답 설명: (A) 자전거를 타고 있지 않음, (B) 서있지 않음, (D) 자전거가 벤치에 기대어 있지 않고 옆에 있음",
  },
  {
    questionNumber: 6,
    choices: {
      A: "The hikers are climbing a steep rock.",
      B: "The hikers are setting up a tent.",
      C: "The hikers are walking along a trail.",
      D: "The hikers are taking a break on a bench.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 등산객들이 산책로를 따라 걷고 있음\n" +
      "오답 설명: (A) 가파른 바위를 오르지 않음, (B) 텐트를 설치하지 않음, (D) 벤치에서 쉬지 않음",
  },
  {
    questionNumber: 7,
    choices: {
      A: "The hikers are climbing down a mountain.",
      B: "The hikers are pitching a tent.",
      C: "The hikers are sitting by a campfire.",
      D: "The hikers are crossing a river.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 등산객들이 산을 내려가고 있음\n" +
      "오답 설명: (B) 텐트를 설치하지 않음, (C) 캠프파이어 옆에 앉아있지 않음, (D) 강을 건너지 않음",
  },
  {
    questionNumber: 8,
    choices: {
      A: "The hikers are carrying backpacks.",
      B: "The hikers are setting up a tent.",
      C: "The hikers are crossing a bridge.",
      D: "The hikers are using walking sticks.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 등산객들이 배낭을 메고 있음\n" +
      "오답 설명: (B) 텐트를 설치하지 않음, (C) 다리를 건너지 않음, (D) 등산 스틱을 사용하지 않음",
  },
  {
    questionNumber: 9,
    choices: {
      A: "The hikers are looking at a map.",
      B: "The hikers are roasting marshmallows over a fire.",
      C: "The hikers are crossing a wooden bridge.",
      D: "The hikers are taking a nap under a tree.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 등산객들이 지도를 보고 있음\n" +
      "오답 설명: (B) 불에 마시멜로를 굽지 않음, (C) 나무 다리를 건너지 않음, (D) 나무 아래서 낮잠 자지 않음",
  },
  {
    questionNumber: 10,
    choices: {
      A: "The hiker is taking a photograph.",
      B: "The hiker is reading a map.",
      C: "The hiker is setting up a tent.",
      D: "The hiker is drinking water.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 등산객이 사진을 찍고 있음\n" +
      "오답 설명: (B) 지도를 읽지 않음, (C) 텐트를 설치하지 않음, (D) 물을 마시지 않음",
  },
  {
    questionNumber: 11,
    choices: {
      A: "The people are lighting a campfire.",
      B: "The people are hiking on a trail.",
      C: "A tent is being set up.",
      D: "The people are swimming in the lake.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 텐트가 설치되고 있음\n" +
      "오답 설명: (A) 캠프파이어를 피우지 않음, (B) 하이킹하지 않음, (D) 호수에서 수영하지 않음",
  },
  {
    questionNumber: 12,
    choices: {
      A: "The people are roasting food over a campfire.",
      B: "Some people are setting up a tent.",
      C: "A group of hikers is climbing a mountain.",
      D: "The campers are taking a nap in their sleeping bags.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 사람들이 모닥불 위에서 음식을 굽고 있음\n" +
      "오답 설명: (B) 텐트를 설치하지 않음, (C) 산을 오르지 않음, (D) 침낭에서 자지 않음",
  },
  {
    questionNumber: 13,
    choices: {
      A: "The woman is watering the plants.",
      B: "The woman is picking apples from a tree.",
      C: "The woman is trimming the bushes.",
      D: "The woman is planting flowers.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 여자가 식물에 물을 주고 있음\n" +
      "오답 설명: (B) 사과를 따지 않음, (C) 관목을 다듬지 않음, (D) 꽃을 심지 않음",
  },
  {
    questionNumber: 14,
    choices: {
      A: "The woman is watering the plants.",
      B: "The woman is trimming the bushes.",
      C: "The woman is raking leaves.",
      D: "The woman is planting a flower.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 여자가 꽃을 심고 있음\n" +
      "오답 설명: (A) 물을 주지 않음, (B) 관목을 다듬지 않음, (C) 낙엽을 긁지 않음",
  },
  {
    questionNumber: 15,
    choices: {
      A: "The man is trimming the bushes.",
      B: "The man is painting a fence.",
      C: "The man is putting on goggles.",
      D: "The man is watering the plants.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 남자가 관목을 다듬고 있음\n" +
      "오답 설명: (B) 울타리를 칠하지 않음, (C) 고글을 쓰고 있음, (D) 물을 주지 않음",
    imageUrl: "/images/part1/people/outdoor/outdoor15.png",
    audioUrl: "/audios/part1/people/outdoor/outdoor15.mp3",
  },
  {
    questionNumber: 16,
    choices: {
      A: "The woman is wearing boots.",
      B: "The woman is raking leaves.",
      C: "The woman is carrying a basket of flowers.",
      D: "The woman is sitting under a tree.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 여자가 장화를 신고 있음\n" +
      "오답 설명: (B) 낙엽을 긁지 않음, (C) 꽃바구니를 들고 있지 않음, (D) 나무 아래 앉아있지 않음",
  },
  {
    questionNumber: 17,
    choices: {
      A: "The woman is kneeling on the grass.",
      B: "The woman is sitting on a chair in the garden.",
      C: "The woman is planting flowers.",
      D: "The woman is trimming bushes.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "오답 설명: (B) 의자가 있지만 사용하지 않고 무릎을 꿇고 있음 → 상태 오류, (C) 꽃을 심는 것이 아니라 물을 주는 중임 → 동작 오류, (D) 덤불이 아니라 식물에 물을 주고 있음 → 동작 오류",
    imageUrl: "/images/part1/people/outdoor/outdoor17.png",
    audioUrl: "/audios/part1/people/outdoor/outdoor17.mp3",
  },
  {
    questionNumber: 18,
    choices: {
      A: "The man is raking leaves in the yard.",
      B: "A man is planting flowers in the garden.",
      C: "The man is shoveling snow from the driveway.",
      D: "A worker is trimming the bushes near the house.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 남자가 마당에서 낙엽을 긁고 있음\n" +
      "오답 설명: (B) 꽃을 심지 않음, (C) 눈을 치우지 않음, (D) 관목을 다듬지 않음",
  },
  {
    questionNumber: 19,
    choices: {
      A: "The man is using a rake to clear the snow.",
      B: "A man is shoveling snow in a snowy field.",
      C: "The worker is sweeping the road with a broom.",
      D: "A man is carrying firewood across the snow.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 남자가 눈 덮인 들판에서 삽으로 눈을 치우고 있음\n" +
      "오답 설명: (A) 갈퀴로 눈을 치우지 않음, (C) 빗자루로 길을 쓸지 않음, (D) 장작을 나르지 않음",
  },
  {
    questionNumber: 20,
    choices: {
      A: "The woman is raking leaves into a pile.",
      B: "A gardener is planting flowers in the garden.",
      C: "The woman is crouching while picking up leaves.",
      D: "A woman is sitting on a chair outside.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여자가 쪼그려 앉아 낙엽을 줍고 있음\n" +
      "오답 설명: (A) 갈퀴로 낙엽을 긁지 않음, (B) 꽃을 심지 않음, (D) 의자에 앉아있지 않음",
  },

  {
    questionNumber: 21,
    choices: {
      A: "The hikers are walking along a mountain trail.",
      B: "The hikers are setting up a tent.",
      C: "The hikers are climbing a rock face.",
      D: "The hikers are rowing a boat.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 등산객들이 산길을 걷고 있음\n" +
      "오답 설명: (B) 텐트를 설치하지 않음, (C) 암벽을 등반하지 않음, (D) 보트를 타지 않음",
  },
  {
    questionNumber: 22,
    choices: {
      A: "The woman is running on a track.",
      B: "The woman is holding a water bottle.",
      C: "The woman is stretching her legs.",
      D: "The woman is tying her shoelaces.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 여성이 신발 끈을 묶고 있음\n" +
      "오답 설명: (A) 트랙을 달리지 않음, (B) 물병을 들고 있지 않음, (C) 다리 스트레칭을 하지 않음",
  },
  {
    questionNumber: 23,
    choices: {
      A: "The people are riding snowmobiles.",
      B: "The people are skiing on a snowy slope.",
      C: "The people are building a snowman.",
      D: "The people are ice skating on a frozen lake.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 사람들이 눈 덮인 슬로프에서 스키를 타고 있음\n" +
      "오답 설명: (A) 스노모빌을 타지 않음, (C) 눈사람을 만들지 않음, (D) 빙판에서 스케이트를 타지 않음",
  },
  {
    questionNumber: 24,
    choices: {
      A: "The athlete is running on a track.",
      B: "The athlete is tying his shoelaces.",
      C: "The athlete is jumping over a hurdle.",
      D: "The athlete is sitting on a bench.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 선수가 허들을 넘고 있음\n" +
      "오답 설명: (A) 단순히 달리지 않음, (B) 신발 끈을 묶지 않음, (D) 벤치에 앉아있지 않음",
  },
  {
    questionNumber: 25,
    choices: {
      A: "The workers are emptying a trash can.",
      B: "The workers are carrying garbage bags and brooms.",
      C: "The workers are sweeping the street.",
      D: "The workers are picking up leaves.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 작업자들이 쓰레기 봉투와 빗자루를 들고 있음\n" +
      "오답 설명: (A) 쓰레기통을 비우고 있지 않음, (C) 거리를 쓸고 있지 않음, (D) 낙엽을 줍고 있지 않음",
  },
  {
    questionNumber: 26,
    choices: {
      A: "The worker is sweeping the leaves.",
      B: "The worker is carrying a trash bag.",
      C: "The man is equipped with a machine.",
      D: "The worker is planting flowers.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 남자가 기계를 착용/장착하고 있음\n" +
      "오답 설명: (A) 낙엽을 쓸고 있지 않음, (B) 쓰레기 봉투를 들고 있지 않음, (D) 꽃을 심고 있지 않음",
  },
  {
    questionNumber: 27,
    choices: {
      A: "The child is walking on a log.",
      B: "The child is jumping over a fence.",
      C: "The boy is sitting on the grass.",
      D: "The boy is running across a bridge.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 아이가 통나무 위를 걷고 있음\n" +
      "오답 설명: (B) 울타리를 뛰어넘지 않음, (C) 잔디에 앉아있지 않음, (D) 다리를 건너 달리지 않음",
  },
  {
    questionNumber: 28,
    choices: {
      A: "The hikers are climbing a steep hill.",
      B: "The people are sitting on a bench.",
      C: "The hikers are setting up a tent.",
      D: "The hikers are walking down a path.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 등산객들이 길을 따라 내려가고 있음\n" +
      "오답 설명: (A) 가파른 언덕을 오르고 있지 않음, (B) 벤치에 앉아있지 않음, (C) 텐트를 설치하고 있지 않음",
  },
  {
    questionNumber: 29,
    choices: {
      A: "The group is climbing a mountain.",
      B: "The people are setting up a tent.",
      C: "The hikers are crossing a stream.",
      D: "The friends are swimming in a lake.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 등산객들이 시냇물을 건너고 있음\n" +
      "오답 설명: (A) 산을 오르고 있지 않음, (B) 텐트를 설치하고 있지 않음, (D) 호수에서 수영하고 있지 않음",
  },

  {
    questionNumber: 31,
    choices: {
      A: "The people are sitting on a bench.",
      B: "The hikers are climbing a mountain.",
      C: "The group is walking across a bridge.",
      D: "The children are playing in the water.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 그룹이 다리를 건너가고 있음\n" +
      "오답 설명: (A) 벤치에 앉아있지 않음, (B) 산을 오르고 있지 않음, (D) 아이들이 물에서 놀고 있지 않음",
  },
];
